
export const userAlertsFeatureName = 'userAlertsModule';

export type UserAlertsState = Readonly<{}>;
